<template>
    <div>
        <DebtActionButtons :pre-trial-comment.sync="preTrialComment" @createPreTrialNotice="createPreTrialNotice" />
        <ContractsDebtFilter :filter-model="filter" @resetFilter="resetFilter" @applyFilter="applyFilter" />
        <ContractsDebtTable :selected.sync="selected" :item-start.sync="itemStart" :items-per-page="itemsPerPage" :is-loading="isLoading" />
    </div>
</template>

<script>
import ContractsDebtTable from '@/components/debts-info/contractsDebt/ContractsDebtTable.vue';
import ContractsDebtFilter from '@/components/debts-info/contractsDebt/ContractsDebtFilter.vue';
import { mapActions, mapGetters } from 'vuex';
import DebtActionButtons from '@/components/debts-info/DebtActionButtons.vue';
import ContractsService from '@/services/apiRequests/contracts.service';
import ActsService from '@/services/apiRequests/acts.service';

export default {
    name: 'ContractsDebt',
    components: { DebtActionButtons, ContractsDebtFilter, ContractsDebtTable },
    data: function() {
        return {
            itemStart: 0,
            itemsPerPage: 10,
            filter: {
                sum_debt: null,
                object_name: null,
                isServiceConnected: null,
                contract_number: null,
                selectedDistrictRid: null,
                notice_status_type_rid: null,
                selectedAddress: {}
            },
            isLoading: false,
            selected: [],
            preTrialComment: ''
        };
    },
    computed: {
        ...mapGetters('contracts', ['getRowCount'])
    },
    provide: function() {
        return {
            saveAct: this.saveAct,
            getActPdf: this.getActPdf,
            getActSignInfo: this.getActSignInfo,
            postActSign: this.postActSign
        };
    },
    methods: {
        ...mapActions('refs', ['getInspectors', 'getInjuctions', 'getReasons', 'getActions', 'getShutdown', 'getHeatingSystem']),
        ...mapActions('contracts', ['setFilterOptions', 'getContractDebt']),
        ...mapActions('base', ['showMessage']),
        applyFilter() {
            this.itemStart = 0;
            if (this.filter.sum_debt) {
                this.filter.sum_debt = Number(this.filter.sum_debt);
            }
            this.setFilterOptions(this.filter);
            this.fetchData();
        },
        resetFilter() {
            this.itemStart = 0;
            this.filter = {
                sum_debt: null,
                object_name: null,
                isServiceConnected: null,
                contract_number: null,
                selectedDistrictRid: null,
                notice_status_type_rid: null,
                selectedAddress: {}
            };
            this.setFilterOptions(this.filter);
            this.fetchData();
        },
        async fetchData() {
            this.isLoading = true;
            const payload = {
                currentItem: this.itemStart,
                itemsPerPage: this.itemsPerPage
            };
            await this.getContractDebt(payload);
            this.isLoading = false;
        },
        async createPreTrialNotice() {
            if (!this.selected.length) {
                await this.showMessage({ message: 'Выберите хотя бы одну позицию', color: 'error' });
                return;
            }
            const payload = {
                comment: this.preTrialComment,
                contracts: this.selected.map(contract => contract.record_id)
            };
            const response = await ContractsService.createPreTrialNotice(payload);
            if (response.successfull) {
                await this.showMessage({
                    message: 'Досудебное уведомление по выбранным позициям созданы. Для просмотра можно перейти в раздел “Досудебные уведомления”'
                });
            }
        },
        saveAct(payload) {
            return ActsService.addContractAct(payload);
        },
        getActPdf(record_id) {
            const payload = { acts: [record_id] };
            return ActsService.getContractsActPDF(payload);
        },
        getActSignInfo(act_rid) {
            return ActsService.getContractActInfoToSign(act_rid);
        },
        postActSign(payload) {
            return ActsService.postContractActSign(payload);
        }
    },
    watch: {
        itemStart: {
            handler: function() {
                this.fetchData();
            },
            immediate: true
        }
    },
    async mounted() {
        await this.getInspectors();
        await this.getInjuctions();
        await this.getReasons();
        await this.getActions();
        await this.getShutdown();
        await this.getHeatingSystem();
    }
};
</script>

<style lang="scss"></style>
